import { deserialize } from 'cerialize'
import {
	BankGuaranteeKinds,
	BankGuaranteeTypes,
	CustomerModel,
	LotModel,
	PurchaseType,
} from 'Pages/ibro'
import moment from 'moment/moment'

export class BankGuaranteeBuild {
	@deserialize public fullname!: string
	@deserialize public inn?: string
	@deserialize public customerregnum!: string
	@deserialize public customeraddress!: string
	@deserialize public customername!: string
	@deserialize public customerinn!: string
	@deserialize public customerkpp!: string
	@deserialize public purchamount!: number
	@deserialize public customerapplicationguarantee!: number
	@deserialize public customercontractguarantee!: number
	@deserialize public customerwarrantyguarantee!: number
	@deserialize public purchaseidentificatcodeikz!: string
	@deserialize public placingwayname!: string
	@deserialize public purchname!: string
	@deserialize public registrationdate!: string
	@deserialize public lotnumber!: number
	@deserialize public placerinn!: string
	@deserialize public placername!: string
	@deserialize public placeraddress!: string
	@deserialize public customer_attributes?: CustomerModel[]
	@deserialize public lot_attributes?: LotModel[]
	@deserialize public ptype!: BankGuaranteeTypes
	@deserialize public kind?: BankGuaranteeKinds
	@deserialize public requestdate!: string
	@deserialize public shortname!: string
	@deserialize public principalinn!: string
	@deserialize public purchasecode?: string
	@deserialize public url?: string
	@deserialize public purchasetype!: PurchaseType
	@deserialize public lotname?: string

	public get formatedRequestDate(): string | null {
		if (!this?.requestdate) return null
		return moment.utc(this?.requestdate).format('LL')
	}
}
